import React, { useEffect } from "react";
import Div from "../Div";
import PageHeading from "../PageHeading";
import Spacing from "../Spacing";

// Shared layout for the Privacy Policy and Terms & Conditions pages.
export default function LegalPage({ title, updated, children }) {
  useEffect(() => {
    document.title = `${title} | Skew`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <>
      <PageHeading
        title={title}
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText={title}
      />
      <Spacing lg="100" md="60" />
      <Div className="container cs-legal_page">
        <p>
          <em>Last updated: {updated}</em>
        </p>
        {children}
      </Div>
      <Spacing lg="100" md="60" />
    </>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <>
      <Spacing lg="30" md="20" />
      <h2 className="cs-font_28 cs-primary_color">{heading}</h2>
      {children}
    </>
  );
}
